<template>
  <div class="mt-n2">
    <v-subheader class="pl-4 pb-0 grey lighten-4">
      <span class="text-h6 font-weight-light">TERMOSTATI ESTERNI</span>
    </v-subheader>
    <v-divider class="mb-2" />
    <ThermElement :therm="therm" v-for="therm in ext_therms" :key="therm.sid" />
    <v-subheader class="pl-4pb-0 grey lighten-4">
      <span class="text-h6 font-weight-light ">TERMOSTATI SERRE</span>
    </v-subheader>
    <v-divider class="mb-2" />
    <ThermElement :therm="therm" v-for="therm in therms" :key="therm.sid" />
  </div>
</template>

<script>
import therm_main_mixin from "../mixin/therm_main_mixin";
import ThermElement from "./therm_element_mobile.vue";
export default {
  name: "ThermMobile",
  mixins: [therm_main_mixin],
  components: {
    ThermElement,
  },
};
</script>
